exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-pencil {\n  width: 2rem;\n  height: 2rem;\n}\n", ""]);
